import { ResponseI } from '@/interfaces/response.interface'
import { UserI, UserInterface } from '@/interfaces/user.interface'
import axios from '@/services/base.service'
import { AxiosResponse } from 'axios'
import { getLocationsWhereUserIsBoss } from '@/services/seller.service'

const resource = 'users'

export const updateUser = async (
  user: any
): Promise<AxiosResponse<ResponseI<UserI>>> => {
  return await axios.put(resource, user)
}

export const getMyData = async (): Promise<AxiosResponse<any>> => {
  return await axios.get('/me')
}

export interface LocationWhereBoss {
  id: number
  name?: string
  [key: string]: unknown
}

export class UserService {
  private static currentUser: UserInterface | null = null
  private static locationsWhereBoss: LocationWhereBoss[] = []

  static async getUserData(): Promise<UserInterface | null> {
    try {
      const response = await getMyData()
      this.currentUser = response.data
      return this.currentUser
    } catch (error) {
      console.error('Error getting user data:', error)
      this.currentUser = null
      return null
    }
  }

  static getCurrentUser(): UserInterface | null {
    return this.currentUser
  }

  static clearUserData(): void {
    this.currentUser = null
  }

  static isBusinessAdmin(user: UserInterface | null): boolean {
    return user?.business_admin === 1
  }

  static isSalesBoss(): boolean {
    const u = this.currentUser as (UserInterface & { is_boss?: boolean }) | null
    if (u?.is_boss === true) return true
    return this.locationsWhereBoss.length > 0
  }

  static getLocationsWhereBoss(): LocationWhereBoss[] {
    return this.locationsWhereBoss
  }

  static async loadLocationsWhereBoss(): Promise<LocationWhereBoss[]> {
    try {
      const res = await getLocationsWhereUserIsBoss()
      const list = res?.data?.data ?? []
      this.locationsWhereBoss = Array.isArray(list) ? list : []
      return this.locationsWhereBoss
    } catch {
      this.locationsWhereBoss = []
      return []
    }
  }

  static isAuthenticated(): boolean {
    return !!localStorage.getItem('access_token')
  }
}
